$.fn.postcode = function() {
    if ("geolocation" in navigator && String(location.protocol).match(/^https/)) {
        $(this)
            .parent()
                .addClass("input-group")
                .append($(
                    "<span class='input-group-btn'></span>"
                    ).append($(
                        "<button class='btn btn-primary'>" +
                            "<span class='fa fa-map-marker'></span>" +
                        "</button>")
                    ).click(function() {
                        navigator.geolocation.getCurrentPosition(
                            function(pos) {
                                $("input[name=postcode]").val(
                                    pos.coords.latitude + "," + pos.coords.longitude
                                ).attr("readonly", true);
                            },
                            function() {
                                $("input[name=postcode]")
                                    .focus()
                                    .parent()
                                        .removeClass("input-group")
                                        .find(".input-group-btn")
                                            .remove();
                            }
                        );
                        return false;
                    })
                );
    }
};
